import { PortInPoolItem } from '@smarty-nx/data'
import dayjs from 'dayjs'

import { pacRegex, stacRegex } from './regex'

export const MINIMUM_AGE = 16
export const MAXIMUM_AGE = 115
export const GROUP_MINIMUM_AGE = 18

export const validatePacOrStac = (value: string) =>
  value && !(pacRegex.test(value) || stacRegex.test(value))
    ? 'Please enter a valid PAC/STAC code'
    : undefined

export const isFullUKNUmber = (num: string) =>
  num &&
  ((num.startsWith('+44') && num.length >= 13) ||
    (num.startsWith('44') && num.length >= 12) ||
    (num.startsWith('07') && num.length >= 11))

export const validateFullUKNUmber = (num: string) =>
  !isFullUKNUmber(num) ? 'Please enter a valid UK phone number' : undefined

export const validateShortPhoneNumber = (num: string) =>
  num &&
  ((num.startsWith('7') && num.length === 10) ||
    (num.startsWith('07') && num.length === 11))
    ? undefined
    : 'Number invalid'

// - If it starts with a '0', it can be 10 digits long.
// - If it doesn't start with a '0', it has to be 9 digits long.
export const validatePhoneNumber = (value: string) =>
  value && !/^(0[0-9]{10}|[1-9][0-9]{9})$/g.test(value)
    ? 'Please enter a valid UK phone number.'
    : undefined

export const validateStacCode = (value: string) =>
  value && !stacRegex.test(value) ? 'Please enter a valid STAC code' : undefined

export const validatePacCode = (value: string) =>
  value && !pacRegex.test(value) ? 'Please enter a valid PAC code' : undefined

export const isUserAboveAge = (dob: string, threshold: number): boolean => {
  const age = dayjs().diff(dayjs(dob, 'DD/MM/YYYY'), 'years', false)
  return age >= threshold
}

export const isUserAboveEighteen = (dob: string): boolean => {
  return isUserAboveAge(dob, GROUP_MINIMUM_AGE)
}

export const isRequired = (value: string) =>
  value ? undefined : 'Please select'

export const isDuplicate = (
  key: 'msisdn' | 'code',
  value: string,
  addedDetails: PortInPoolItem[]
) => {
  if (addedDetails.some((detail: PortInPoolItem) => detail[key] === value)) {
    return 'Duplicate value provided'
  }
  return undefined
}
